import { render, staticRenderFns } from "./ReceiveInvoice.vue?vue&type=template&id=3356cad8&"
import script from "./ReceiveInvoice.vue?vue&type=script&lang=js&"
export * from "./ReceiveInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports